import api from "..";
import API_ENDPOINTS from "../endpoints";

export const getEventDetails = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.EVENT_DETAILS,
    params: {
      event_id: data.event_id,
    },
  });

  return response.data;
};

export const getEventJoinedTeams = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.EVENT_JOINED_TEAMS,
    params: {
      event_id: data.event_id,
      page: data?.page || 1,
      limit: data?.limit || 50,
    },
  });

  return response.data;
};
